import React from "react";
import { ShieldCheck, GraduationCap, Wrench } from "lucide-react";
import { HV } from "@/constants/testIds";

export default function HvInvestment() {
  return (
    <section
      data-testid={HV.section}
      className="section relative overflow-hidden border-y border-[var(--owrs-border)]"
      style={{ background: "linear-gradient(180deg, #060b11 0%, #0a1622 50%, #060b11 100%)" }}
    >
      <div className="absolute inset-0 grid-bg opacity-25 pointer-events-none" />
      <div className="absolute -right-32 -top-32 h-96 w-96 rounded-full bg-[var(--owrs-accent)]/10 blur-3xl pointer-events-none" />
      <div className="container-owrs relative">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7">
            <div className="overline mb-4">03 — HV Investment</div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tighter leading-[1.05] mb-8">
              Every technician on our team is{" "}
              <span className="text-[var(--owrs-accent)]">IMI-certified for HV work.</span>
            </h2>
            <p className="text-lg text-[var(--owrs-text-muted)] leading-relaxed mb-6">
              Working safely on electric and hybrid vehicles is not optional — it is the
              difference between a repair and a serious incident. That is why we have put our
              entire workforce through formal IMI-aligned high-voltage safety and repair
              training, equipping the workshop accordingly.
            </p>
            <p className="text-base text-[var(--owrs-text-muted)] leading-relaxed">
              From isolation procedures and PPE through to module-level battery diagnostics,
              we follow manufacturer-grade processes on every single job — whether it is a
              12V battery replacement or a full HV pack swap.
            </p>
          </div>

          <div className="lg:col-span-5 grid gap-4">
            <Pillar
              icon={<GraduationCap className="h-5 w-5" />}
              title="IMI-Certified Training"
              body="IMI-aligned high-voltage qualifications held across the entire workforce."
            />
            <Pillar
              icon={<ShieldCheck className="h-5 w-5" />}
              title="HV Safety First"
              body="Isolation, PPE, and lock-out procedures on every EV job — no shortcuts."
            />
            <Pillar
              icon={<Wrench className="h-5 w-5" />}
              title="Specialist Tooling"
              body="HV-rated insulated tooling, diagnostic interfaces and battery handling equipment."
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function Pillar({ icon, title, body }) {
  return (
    <div className="surface p-6 flex gap-4 group hover:border-[var(--owrs-accent)]/40 transition-colors">
      <div className="h-11 w-11 shrink-0 inline-flex items-center justify-center bg-[var(--owrs-accent)] text-[var(--owrs-surface)]">
        {icon}
      </div>
      <div>
        <div className="font-display text-lg font-medium mb-1 uppercase">{title}</div>
        <div className="text-sm text-[var(--owrs-text-muted)] leading-relaxed">{body}</div>
      </div>
    </div>
  );
}
